export default {"src":"/_next/static/media/conflictsManagement.27800c37.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};